import { ReactNode } from 'react';
import { LucideIcon } from 'lucide-react';

interface ReportSectionProps {
  title: string;
  icon?: LucideIcon;
  children: ReactNode;
  className?: string;
}

export function ReportSection({ title, icon: Icon, children, className = '' }: ReportSectionProps) {
  return (
    <div className={`report-section print-break-avoid ${className}`}>
      <h2 className="report-section-title">
        {Icon && <Icon className="text-primary-600" size={32} />}
        {title}
      </h2>
      <div className="report-section-content">{children}</div>
    </div>
  );
}
